import type { IExtractRouteParamMap, IRouteTranslation } from "../../../types";
import { createBreadcrumbObject, createPaths, rebase } from "../../../utils";

// Base route constant
const baseRoute = `/conference-papers`;

// * Route configuration object for conferencePapers-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const conferencePapersRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  view: `${baseRoute}/view/:conferencePaperId`,
  edit: `${baseRoute}/edit/:conferencePaperId`,
} as const;

// ! these are breadcrumbs translation not page title
const conferencePaperRouteTranslation: IRouteTranslation<
  typeof conferencePapersRoutesObj
> = {
  list: "conferencePapersList",
  create: "addPaper",
  edit: "editPaper",
  view: "viewPaper",
};

// * Extracts the route parameters for the conferencePapers route configuration.
export type IConferencePapersRouteParams = IExtractRouteParamMap<
  typeof conferencePapersRoutesObj
>;

// * Path functions for the conferencePapers routes.
export const conferencePapersPath = createPaths<
  typeof conferencePapersRoutesObj,
  IConferencePapersRouteParams
>(conferencePapersRoutesObj);

// * Breadcrumbs {translation and route} for the faculty routes
export const conferencePaperBreadcrumbs = createBreadcrumbObject<
  typeof conferencePapersRoutesObj
>(conferencePapersRoutesObj, conferencePaperRouteTranslation);
rebase(conferencePaperBreadcrumbs, "list");
